import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "FlowCraft",
    description: "FlowCraft links all your systems and builds the workflows for you, so your software works as one team without the engineering backlog.",
    url: getOrigin(),
    // Point these at the FlowCraft profiles once they exist.
    socials: [
        { id: 'x', label: "FlowCraft on X", href: 'https://x.com' },
        { id: 'youtube', label: "FlowCraft on YouTube", href: 'https://www.youtube.com' },
        { id: 'instagram', label: "FlowCraft on Instagram", href: 'https://www.instagram.com' },
        { id: 'linkedin', label: "FlowCraft on LinkedIn", href: 'https://www.linkedin.com' },
        { id: 'tiktok', label: "FlowCraft on TikTok", href: 'https://www.tiktok.com' },
        { id: 'facebook', label: "FlowCraft on Facebook", href: 'https://www.facebook.com' }
    ]
}
